export default __webpack_public_path__ + "static/media/md-card-bg-ITIL4.51743acc.png";